<template>
  <div>
    <px-view-header title="Categorias" :breadcrumbs="breadcrumbs"/>

    <px-categoria-header @refresh="refresh" @change="onChangeFilter"/>
    <px-categoria-list
      @update="refresh"
      :categorias="categorias"
      :loading="loading"
      @change="onChangeOptions"
      :options-list="optionsList"
    />
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import CategoriaService from '@/modules/marketplace/categoria/categoria-service';
import CategoriaHeader from './CategoriaHeader.vue';
import CategoriaList from './CategoriaList.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Categorias' },
      ],
      searchText: null,
      categorias: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 25,
        offset: 0,
        filter: '',
        sort: 'descricao',
      },
      loading: false,
      optionsList: {},
    };
  },
  methods: {
    refresh() {
      this.getCategorias();
    },
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getCategorias();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCategorias();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCategorias() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CategoriaService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.categorias = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxCategoriaHeader: CategoriaHeader,
    pxCategoriaList: CategoriaList,
  },
};
</script>
